import { all, takeEvery, put, call } from "redux-saga/effects";
import * as wifi from "./services";
import { push } from "connected-react-router";
import { actions } from "./reducers";

export function* REQUEST_TOKEN({ payload }) {
  const tokenRes = yield call(wifi.getToken, payload);
  yield put({
    type: "wifi/RECEIVE_TOKEN",
    payload: tokenRes,
  });
  yield put({
    type: "global/RECEIVE_SESSION_DETAILS",
    payload: tokenRes,
  });

  if (tokenRes.error) {
    if (tokenRes.type === "WEB") {
      yield put(push("/dashboard"));
    } else {
      yield put(push("/not-found"));
    }
  }
}

export function* REQUEST_PRODUCTS({ payload }) {
  yield put({
    type: "wifi/SET_LOADING",
    payload: true,
  });
  const { token, subcategory } = payload;
  const productsRes = yield call(wifi.getProducts, token, subcategory);
  if (productsRes) {
    yield put({
      type: "wifi/SET_LOADING",
      payload: false,
    });
  }
  yield put({
    type: "wifi/RECEIVE_PRODUCTS",
    payload: productsRes,
  });
}

export function* REQUEST_BUY_WIFI({ payload }) {
  const reqPayload = {
    sku: payload.product,
    recipientMobile: payload["Account/Mobile Number"],
    sessionId: payload.sessionId,
    userId: payload.userId,
    category: payload.category,
  };
  const { token } = payload;
  const res = yield call(wifi.buyWifi, reqPayload, token);
  const resPayload = {
    "Account/Mobile Number": payload["Account/Mobile Number"],
    telco: payload.telco,
    product: payload.product,
    amount: payload.amount,
    discount: parseFloat(payload.discount.toFixed(2)),
    netTotal: payload.amount - payload.discount,
  };

  if (res.error) {
    yield put({
      type: "global/RECEIVE_TRANSACTION_OUTPUT",
      payload: { ...res, result: res.error },
    });
    yield put({
      type: "wifi/RECEIVE_BUY_WIFI",
      payload: { ...resPayload, result: res.error },
    });
    yield put(push("/result"));
  } else {
    yield put({
      type: "global/RECEIVE_TRANSACTION_OUTPUT",
      payload: { ...res, result: "success" },
    });
    yield put({
      type: "wifi/RECEIVE_BUY_WIFI",
      payload: { ...resPayload, result: "success" },
    });
    if (payload.sessionType === "BOT") {
      yield put(push("/result"));
    }
  }
}

export function* REQUEST_TRANSACTIONS({ payload }) {
  yield put({
    type: "wifi/SET_LOADING",
    payload: true,
  });
  const { limit, token } = payload;
  const transactionsRes = yield call(wifi.getTransactions, token, limit);
  if (transactionsRes) {
    yield put({
      type: "wifi/SET_LOADING",
      payload: false,
    });
  }
  const transactions = transactionsRes.map((transactions) => {
    return {
      status: transactions.status,
      time: transactions.updatedAt,
      amount: transactions.totalPrice,
      name: transactions.items[0].productSku,
      reference: transactions.referenceId,
    };
  });
  yield put({
    type: "wifi/RECEIVE_TRANSACTIONS",
    payload: transactions,
  });
}

export default function* rootSaga() {
  yield all([takeEvery(actions.REQUEST_TOKEN, REQUEST_TOKEN)]);
  yield all([takeEvery(actions.REQUEST_PRODUCTS, REQUEST_PRODUCTS)]);
  yield all([takeEvery(actions.REQUEST_BUY_WIFI, REQUEST_BUY_WIFI)]);
  yield all([takeEvery(actions.REQUEST_TRANSACTIONS, REQUEST_TRANSACTIONS)]);
}
